import { OrderProduct } from "ts/api/order";
import { FullProduct } from "ts/api/product";
import { uniqBy } from "lodash";
import filterNotEmptyArray from "tools/common/filterNotEmptyArray";

type CalculateSupplierProductsFeesAmountParams = {
  products: Pick<FullProduct | OrderProduct, "fees">[];
  includeFees?: boolean;
};

const calculateSupplierProductsFeesAmount = ({
  products,
  includeFees,
}: CalculateSupplierProductsFeesAmountParams): number => {
  const fees = uniqBy(
    products.map((product) => product?.fees).flat(1),
    "id"
  ).filter(filterNotEmptyArray);
  const feesAmount = fees.reduce(
    (acc, cur) => acc + ((includeFees ? cur.amountWithFees : cur.amount) || 0),
    0
  );

  return feesAmount;
};

export default calculateSupplierProductsFeesAmount;
